<div class="slider">
  <div class="slider__range">
    <input
      type="range"
      class="range"
      [class.light]="theme === 'light'"
      [class.dark]="theme === 'dark'"
      [(ngModel)]="value"
      [min]="min"
      [max]="max"
      [disabled]="disabled"
      (dblclick)="handleRangeDoubleClick()">
  </div>

  <div class="slider__input">
    <input type="number" class="input" [(ngModel)]="value" [min]="min" [max]="max" [disabled]="disabled">
  </div>
</div>